module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav",
    class: _vm.notPadded ? 'noPad' : ''
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('logo')], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "toggle",
    class: _vm.expanded ? 'toggled' : '',
    on: {
      "click": _vm.toggleExpanded
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu",
    class: _vm.expanded ? 'is-active' : ''
  }, [_c('div', {
    staticClass: "nav-item has-dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Episodes'
      }
    }
  }, [_c('span', [_vm._v("Stories")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Episodes'
      }
    }
  }, [_vm._v("Episodes")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Books'
      }
    }
  }, [_vm._v("Books")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Extras'
      }
    }
  }, [_vm._v("Extras")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item has-dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'About'
      }
    }
  }, [_c('span', [_vm._v("About")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'About',
        hash: '#show'
      }
    }
  }, [_vm._v("The Show")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'About',
        hash: '#press'
      }
    }
  }, [_vm._v("Press")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'About',
        hash: '#contact'
      }
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'About',
        hash: '#team'
      }
    }
  }, [_vm._v("The Team")]), _vm._v(" "), _c('router-link', {
    staticClass: "resources",
    attrs: {
      "to": {
        name: 'Resources'
      }
    }
  }, [_vm._v("Resources")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "nav-item mob"
  }, [_c('search-module')], 1) : _vm._e(), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "nav-item mob subscribe"
  }, [_c('span', [_vm._v("Subscribe")]), _vm._v(" "), _c('subscribe-module')], 1) : _vm._e()])]), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "scrim",
    on: {
      "click": _vm.unexpand
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://longestshortesttime.supportingcast.fm/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', [_vm._v("Join the Club")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f729ad1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Masthead.vue
// module id = 778
// module chunks = 1